import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';

const Error404 = lazy(() => import('./Error404Page'));

/**
 * The Example page route.
 */
const ExampleRoute: FuseRouteItemType = {
	path: '404',
	element: <Error404 />,
	settings: {
		layout: {
			config: {
				toolbar: {
					title: 'Page not found',
					showCrumbs: false
				}
			}
		}
	}
};

export default ExampleRoute;
